import React from "react";
import styled from "styled-components";
import { Colors, DAYS_OF_WEEK } from "../../config/Constants";

interface Props {
  setOpenOrClose: () => void;
  price: {
    [any: string]: string;
  };
}

const PriceModal = ({ setOpenOrClose, price }: Props) => {
  return (
    <PriceModalContainer>
      <PriceModalHeader>
        <HeaderTitle>Price</HeaderTitle>
        <Close
          src={require("../../assets/images/ei_close.png")}
          alt="close"
          onClick={setOpenOrClose}
        />
      </PriceModalHeader>
      <PriceModalBody>
        {DAYS_OF_WEEK.map((eachDayObj, index) => {
          return (
            <DispFlex key={index}>
              <DayDiv>{eachDayObj.day}</DayDiv>
              <PriceDiv>{price[eachDayObj.key]} QAR</PriceDiv>
            </DispFlex>
          );
        })}
      </PriceModalBody>
    </PriceModalContainer>
  );
};

export default PriceModal;

const PriceModalContainer = styled.div`
  padding: 1.625rem 1.875rem;
`;

const PriceModalHeader = styled.div`
  display: flex;
  justify-content: center;
`;
const HeaderTitle = styled.div`
  font-family: "Poppins-Medium";
  font-size: 1rem;
  color: ${Colors.mineShaft};
`;
const Close = styled.img`
  transform: translate(4.8rem, -0.25rem);
  cursor: pointer;
`;
const PriceModalBody = styled.div`
  padding-top: 1.25rem;
`;
const DispFlex = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0.625rem 0;
`;
const DayDiv = styled.div`
  font-family: "Poppins-Book";
  font-size: 1rem;
  color: ${Colors.dustyGray};
`;
const PriceDiv = styled.div`
  font-family: "Poppins-Medium";
  font-size: 1rem;
  color: ${Colors.purplishGrey};
`;
